<template>
  <div v-if="!loading">
    <div class="ranking-section">
      <p class="ranking-title">
        <span class="material-icons ranking-icon">phone_android</span>
        Top 5 Celulares Comprados
      </p>
      <table class="ranking-table">
        <thead>
          <tr>
            <th class="col-rank">#</th>
            <th>Marca / Modelo</th>
            <th class="col-storage">Almac.</th>
            <th class="col-total">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in topProducts" :key="'prod-' + index">
            <td class="col-rank">
              <span class="rank-badge" :class="'rank-' + (index + 1)">{{ index + 1 }}</span>
            </td>
            <td class="col-name">{{ item.brand }} {{ item.model }}</td>
            <td class="col-storage">{{ item.storage || '—' }}</td>
            <td class="col-total"><span class="total-chip">{{ item.total }}</span></td>
          </tr>
          <tr v-if="!topProducts.length">
            <td colspan="4" class="empty-row">Sin datos</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="ranking-section">
      <p class="ranking-title">
        <span class="material-icons ranking-icon">location_on</span>
        Top 5 Ciudades
      </p>
      <table class="ranking-table">
        <thead>
          <tr>
            <th class="col-rank">#</th>
            <th>Ciudad</th>
            <th class="col-total">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in topCities" :key="'city-' + index">
            <td class="col-rank">
              <span class="rank-badge" :class="'rank-' + (index + 1)">{{ index + 1 }}</span>
            </td>
            <td class="col-name">{{ item.city }}</td>
            <td class="col-total"><span class="total-chip">{{ item.total }}</span></td>
          </tr>
          <tr v-if="!topCities.length">
            <td colspan="3" class="empty-row">Sin datos</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else>
    <loading-component />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'top-rankings',
  data () {
    return {
      loading: false,
      topProducts: [],
      topCities: []
    }
  },
  methods: {
    ...mapActions(['getTopRankings'])
  },
  async beforeMount () {
    this.loading = true
    try {
      const result = await this.getTopRankings()
      if (result) {
        this.topProducts = result.topProducts || []
        this.topCities = result.topCities || []
      }
    } finally {
      this.loading = false
    }
  },
  components: {
    LoadingComponent: () => import('@/components/ui/Loading')
  }
}
</script>

<style scoped>
.ranking-section {
  margin-top: 24px;
}

.ranking-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  color: #4d4f5c;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.ranking-icon {
  font-size: 16px;
  color: var(--secondary-color, #9A2EFE);
}

.ranking-table {
  width: 100%;
  border-collapse: collapse;
}

.ranking-table thead tr {
  border-bottom: 2px solid #f0f0f0;
}

.ranking-table th {
  font-size: 11px;
  font-weight: 600;
  color: #9a9ab0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 4px 8px;
}

.ranking-table td {
  font-size: 13px;
  color: #4d4f5c;
  padding: 7px 8px;
  border-bottom: 1px solid #f5f5f5;
}

.ranking-table tbody tr:last-child td {
  border-bottom: none;
}

.ranking-table tbody tr:hover td {
  background: #fafafa;
}

.col-rank {
  width: 32px;
  text-align: center;
  padding-left: 0 !important;
}

.col-name {
  font-weight: 500;
}

.col-storage {
  width: 56px;
  text-align: center;
  color: #9a9ab0;
  font-size: 12px !important;
}

.col-total {
  width: 48px;
  text-align: right;
}

.rank-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  background: #f0f0f0;
  color: #9a9ab0;
}

.rank-1 { background: #FFD700; color: #7a6200; }
.rank-2 { background: #C0C0C0; color: #555; }
.rank-3 { background: #cd7f32; color: #fff; }

.total-chip {
  display: inline-block;
  background: #f3eeff;
  color: var(--secondary-color, #9A2EFE);
  font-weight: 700;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
}

.empty-row {
  text-align: center;
  color: #bbb;
  font-size: 13px;
  padding: 16px !important;
}
</style>
